export default "__VITE_ASSET__CejfJCec__"